import { Injectable } from '@angular/core';
import { APIURL } from 'src/environments/environment';
import { map, catchError, retry } from 'rxjs/operators';
import { HandleErrorService } from './handle-error.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormOptionsService {
  api = new APIURL();
  constructor(
    private http: HttpClient,
    private handleErrorService: HandleErrorService
  ) {}

  getBancos(): Observable<any> {
    const headers = this.api.headers;
    return this.http.get(this.api.url + '/api/bancos', { headers }).pipe(
      map(response => response),
      retry(3),
      catchError(response => this.handleErrorService.handleError(response))
    );
  }

  getIntensidade(): Observable<any> {
    const headers = this.api.simpleHeaders;
    return this.http
      .get(this.api.url + '/medidas/intensidade', { headers })
      .pipe(
        map(response => response),
        retry(3),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }

  getTexturas(): Observable<any> {
    const headers = this.api.simpleHeaders;
    return this.http.get(this.api.url + '/medidas/textura', { headers }).pipe(
      map(response => response),
      retry(3),
      catchError(response => this.handleErrorService.handleError(response))
    );
  }

  getFrequencia(): Observable<any> {
    const headers = this.api.simpleHeaders;
    return this.http
      .get(this.api.url + '/medidas/frequencia', { headers })
      .pipe(
        map(response => response),
        retry(3),
        catchError(response => this.handleErrorService.handleError(response))
      );
  }
}
